import { PromoData } from "@/types/promoData";

export const CART_ACTION_TYPES = {
  INCREASE: "increase",
  DECREASE: "decrease",
} as const;

export type CartActionType = (typeof CART_ACTION_TYPES)[keyof typeof CART_ACTION_TYPES];
export type CartState = "mixed" | "subscription_only" | "one_time_only" | null;

export interface CartData {
  cart_id: string;
  masked_id: string;
  totals: CartTotals;
  items: Record<string, CartItem> | undefined;
  site: string;
  promos: string[];
  gift_description: string | null;
  gift_url: string | null;
  hide_checkout_discount_field?: boolean;
  hide_checkout_discount_text?: string;
}

export interface CartQuote {
  product_id: string;
  purchase_source: string;
  quote_id: string;
  quote_item_id: string;
  qty: number;
  sku: string;
  price: number;
  item_discount: number;
  row_total: string;
  three_pack_sku: string;
  row_old_price_total: string;
  hsa_fsa_eligibility?: string | null;
}

export interface ChildProductDetail {
  entity_id: string;
  sku: string;
  price: string;
  old_price: string;
  bundled_price: string;
  name: string;
  label1: string;
  url_key: string;
  is_package_product: string;
  admin_only: 0 | 1;
  url: string;
  is_core: boolean;
  core_category: string;
  subscription_type: string;
  billing_interval: string;
  shipping_interval: string;
  product_gender: string;
  product_category: string;
  purchase_type: string;
  qty: number;
}

export type ChildProducts = Record<string, ChildProductDetail> | [];

export interface CartItem {
  purchase_source?: string;
  entity_id: string;
  sku: string;
  is_subscription: 1 | 0;
  price: string;
  old_price: string;
  name: string;
  label1: string;
  url_key: string;
  is_package_product: string;
  admin_only: 0 | 1;
  url: string;
  is_core: boolean;
  core_category: string;
  subscription_type: string;
  billing_interval: string;
  shipping_interval: string;
  product_gender: string;
  product_category: string;
  purchase_type: string;
  business_line: string;
  three_pack_sku: string;
  has_ga: boolean;
  is_bundle: boolean;
  is_skin: boolean;
  short_description: string | null;
  child_products: ChildProducts;
  is_gift: boolean;
  quote: CartQuote;
}

export interface CartTotals {
  grand_total: number;
  subtotal: number;
  discount: number;
  coupon_code: string | null;
  cart_id?: string;
  masked_id?: string;
  coupon_frontend_message: string | null;
  coupon_frontend_confirmation_message: string | null;
  taxes: string;
  shipping: string;
}

/**
 * unified props interface for all upsell components
 * all components should get cartId, theme, coupon from CartContext
 */
export interface UpsellComponentProps {
  product?: CartItem;
  level: "item" | "cart";
  promoCf?: PromoData;
  upsellId?: string;
}

export interface CartUndoData {
  cartId: string;
  coupon: string;
  sku: string;
  itemId: string;
  oldQty: number;
  qty: number;
}

export interface SuggestedAddress {
  street: string[];
  city: string;
  region: {
    code: string;
    label: string;
    region_id: number;
    __typename: string;
  };
  postcode: string;
  country: {
    code: string;
    label: string;
    __typename: string;
  };
  __typename: string;
}
